import { SecondaryButton } from 'jl-design-system/elements/button/Button';

export const CancelButton = (props) => <SecondaryButton {...props}>Cancel</SecondaryButton>;
